import { render } from "./facial-skin-age.vue?vue&type=template&id=d14ad174&scoped=true"
import script from "./facial-skin-age.vue?vue&type=script&lang=js"
export * from "./facial-skin-age.vue?vue&type=script&lang=js"

import "./facial-skin-age.vue?vue&type=style&index=0&id=d14ad174&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14ad174"]])

export default __exports__